import {
    CHILE,
    COUNTRY_SECTION_NAME,
    HEAR_ABOUT_US_SECTION_NAME,
    SHOP_FORM_SECTION_NAME,
    VENDOR_FORM_SECTION_NAME,
} from "../../constants";
import Validator from 'validatorjs';
import rutValidator from "../rutValidator/rutValidator";

Validator.register('rut', (value, requirement, attribute) => {
    const result = rutValidator.isValidRut(value);
    return result;
}, 'El rut no es válido');

Validator.register('repeat_email_val', (value, requirement, attribute) => {
    const result = value.value === value.comparison;
    return result;
}, 'Ambos correos deben ser iguales');


const getSectionsRules = (countryCode) => {
    if (countryCode === CHILE.value) {
        /** VALIDATION RULES FOR CHILE **/
        return {
            [VENDOR_FORM_SECTION_NAME]: {
                name: 'required',
                lastname: 'required',
                phone: 'required|regex:/\\+56[0-9]{9}/|max:13',
                email: 'required|email',
                repeat_email: 'required|repeat_email_val',
                document_number: 'required|rut|max:12|min:11',
            },
            [SHOP_FORM_SECTION_NAME]: {
                commercial_name: 'required',
                business_name: 'required',
                main_category: 'required',
                economic_activity: 'required|array',
                id_social_reason: 'required|rut|max:13|min:11',
            },
            [HEAR_ABOUT_US_SECTION_NAME]: {
                hear_about_us: 'required',
            },
            [COUNTRY_SECTION_NAME]: {
                country: 'required',
            },
        };
    }
    else {
        /** VALIDATION RULES FOR PERU **/
        return {
            [VENDOR_FORM_SECTION_NAME]: {
                name: 'required',
                lastname: 'required',
                phone: 'required|regex:/\\d{9}/|max:9',
                email: 'required|email',
                repeat_email: 'required|repeat_email_val',
                document_number: 'required|numeric',
            },
            [SHOP_FORM_SECTION_NAME]: {
                commercial_name: 'required',
                business_name: 'required',
                main_category: 'required',
                id_social_reason: 'required|numeric',
                department: 'required',
                province: 'required',
                asep: 'required|boolean',
                own_fleet: 'required|boolean',
            },
            [HEAR_ABOUT_US_SECTION_NAME]: {
                hear_about_us: 'required',
            },
            [COUNTRY_SECTION_NAME]: {
                country: 'required',
            },
        };
    }
};

const ValidationRules = {
    getBySectionName: (countryCode, sectionName) => {
        const sectionsRules = getSectionsRules(countryCode)
        return sectionsRules[sectionName]
    },
    getAll: (countryCode) => {
      return getSectionsRules(countryCode);
    },
}


export default ValidationRules